import { useCallback, useEffect, useRef, useState } from 'react';

/** How long a drawer, panel or dialog takes to animate out (the `*-out` animations, tailwind.config.cjs). */
export const CLOSE_MS = 140;

/**
 * Plays the closing animation before calling onClose: returns whether it is closing,
 * and the close function to use instead of onClose. A second call while closing does
 * nothing.
 */
export const useClosing = (onClose: () => void): [boolean, () => void] => {
  const [closing, setClosing] = useState(false);
  const timer = useRef<number | undefined>(undefined);
  useEffect(() => () => window.clearTimeout(timer.current), []);
  const close = useCallback(() => {
    if (timer.current !== undefined) return;
    setClosing(true);
    timer.current = window.setTimeout(() => {
      timer.current = undefined;
      setClosing(false);
      onClose();
    }, CLOSE_MS);
  }, [onClose]);
  return [closing, close];
};
